import React, { useContext, useEffect } from "react";
import { FormContext } from "../../context/form/formContext";
import "./index.css";

export const Notification = () => {
  const {
    notif: { message, status },
    setNotification,
  } = useContext(FormContext);
  useEffect(() => {
    status && setTimeout(() => setNotification(false), 6000);
    return () => setTimeout(() => setNotification(false), 6000);
  }, [setNotification, status]);

  return (
    <>
      {status && (
        <div
          className={`notification-container ${
            status === "error" ? "notice-error" : "notice-success"
          }`}
        >
          {message}
        </div>
      )}
    </>
  );
};
